module.exports = __webpack_public_path__ + "img/11.e4135e42.jpg";